import styled from "styled-components";

export const MobileTournamentStructureTable = styled.div`
  display: flex;
  flex-direction: column;
  gap: 8px;
  width: 100%;
`;

export const MobileTournamentStructureItemWrapper = styled.div`
  display: flex;
  flex-direction: column;
  gap: 4px;
  width: 100%;
`;

export const MobileTournamentStructureHeader = styled.div`
  display: flex;
  align-items: center;
  gap: 8px;
  width: 100%;

  > div {
    padding: 0 16px;
    height: 30px;
    border-radius: 8px;
    background: #6436e7;
    font-weight: 600;
    font-size: 12px;
    color: #fff;
    text-align: center;
    line-height: 30px;
  }

  > .level {
    width: 18%;
  }

  > .blind {
    width: 19%;
  }

  > .item {
    width: 22%;
  }
`;

export const MobileTournamentStructureItem = styled.div`
  display: flex;
  align-items: center;
  gap: 8px;
  height: 14px;

  > div {
    font-weight: 500;
    font-size: 12px;
    text-align: center;
  }

  > .level {
    width: 18%;
  }

  > .blind {
    width: 19%;
  }

  > .item {
    width: 22%;
  }
`;

export const MobileTournamentStructureItemBrake = styled.div`
  display: flex;
  align-items: center;
  gap: 8px;
  height: 20px;
  width: 100%;
  background: #d9d9d9;
  justify-content: center;

  > div {
    font-weight: 700;
    font-size: 10px;
    text-align: center;
    line-height: 20px;
  }
`;
